var map = {
	".": 79,
	"./": 79,
	"./imge/app1.png": 317,
	"./imge/app2.png": 318,
	"./imge/app3.png": 319,
	"./imge/app4.png": 320,
	"./imge/app5.png": 321,
	"./imge/app6.png": 322,
	"./imge/apple.png": 137,
	"./imge/background.png": 149,
	"./imge/email.png": 323,
	"./imge/end.png": 324,
	"./imge/footer.png": 105,
	"./imge/google.png": 138,
	"./imge/header.png": 136,
	"./imge/insta.png": 139,
	"./imge/middle.png": 183,
	"./imge/twitter.png": 140,
	"./imge/whats.png": 141,
	"./index": 79,
	"./index.js": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 316;